/**
 * +82, - 있든 없든 010-1111-2222 형식으로 반환
 * @example formatPhoneNumber('+8201011112222') -> '010-1111-2222'
 */
export function formatPhoneNumber(phoneNumber) {
    const cleaned = String(phoneNumber)
        .replace("+82", "")
        .replace(/\D/g, "")
        .trim();
    const match = cleaned.match(/^(01[0|1|6|7|8|9])(\d{3,4})(\d{4})$/);
    if (match) {
        return match[1] + "-" + match[2] + "-" + match[3];
    }
    return phoneNumber;
}
/**
 * +82, - 있든 없든 일반 전화번호(지역번호) 형식으로 반환
 * @example formatTelNumber('+820212345678') -> '02-1234-5678'
 */
export function formatTelNumber(phoneNumber) {
    const cleaned = String(phoneNumber)
        .replace("+82", "")
        .replace(/\D/g, "")
        .trim();
    const match = cleaned.match(/^(0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4]|70))(\d{3,4})(\d{4})$/);
    if (match) {
        return match[1] + "-" + match[3] + "-" + match[4];
    }
    return phoneNumber;
}
